import { render, staticRenderFns } from "./BCXMobileFullscreenDesktopLayer.vue?vue&type=template&id=b262f31e"
import script from "./BCXMobileFullscreenDesktopLayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMobileFullscreenDesktopLayer.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports